export const scrollWithOffset = (el, navbarHeight = 80) => {
    const top = el.getBoundingClientRect().top + window.scrollY - navbarHeight;
    window.scrollTo({ top, behavior: 'smooth' });
};

export const scrollWithDelayOffset = (el, navbarHeight = 80) => {
    setTimeout(() => {
        const top = el.getBoundingClientRect().top + window.scrollY - navbarHeight;
        window.scrollTo({ top, behavior: 'smooth' });
    }, 300);
};